// Shared helpers for the chat confirmation cards (H-3.2).

// Currency formatter shared by the expense-family cards. Falls back gracefully on
// an unknown ISO code.
export const fmtAmt = (amount, currency = 'USD') => {
    if (amount == null) return '—';
    try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format(amount);
    } catch (_) { return `${currency} ${Number(amount).toFixed(2)}`; }
};

// Run a per-item executor over the active rows, tolerating 404 (already gone = the
// goal) unless `tolerate404` is false. Returns { count, failuresText? } — the
// engine sets the card error from failuresText and skips resolving on failure.
// `label(item)` produces the human name used in the failure list.
export async function runPerItem(items, fn, { label, tolerate404 = true, verb = 'process' } = {}) {
    const failures = [];
    for (const it of items) {
        try {
            await fn(it);
        } catch (err) {
            if (tolerate404 && err?.status === 404) continue; // already gone
            failures.push(label ? label(it) : (it?.id || 'item'));
        }
    }
    if (failures.length) {
        const map = { delete: 'Could not delete', update: 'Could not update', attach: 'Could not attach', rename: 'Could not rename' };
        return { count: 0, failuresText: `${map[verb] || 'Could not process'}: ${failures.join(', ')}` };
    }
    return { count: items.length };
}

// Small event dispatch that never throws.
export const emit = (name, detail) => {
    try { window.dispatchEvent(new CustomEvent(name, { detail })); } catch (_) { /* no-op */ }
};

// Shared button classes.
export const rowBtn = (accent = 'rose') => (accent === 'indigo'
    ? 'inline-flex items-center gap-1 px-2 py-1 text-[11px] text-pai-blue bg-white/[0.03] border border-[rgba(74,144,240,0.35)] hover:bg-indigo-50 dark:hover:bg-indigo-900/30 rounded'
    : 'inline-flex items-center gap-1 px-2 py-1 text-[11px] text-rose-700 dark:text-rose-300 bg-white/[0.03] border border-rose-300 dark:border-rose-700 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded');

export const removeBtnClass = 'flex-shrink-0 p-1 text-pai-faint hover:text-rose-600 dark:hover:text-rose-400 disabled:opacity-40';
